import "../styles/commentBody.scss";
import CommentLinkPreview from "./CommentLinkPreview";

const CommentBody = ({ comment }) => {
    if (comment.isDeleted) {
        return (
            <div className="deletedNode">
                <p>
                    <i>
                        [This line of argument has been retracted by the author.]
                    </i>
                </p>
            </div>
        );
    }

    return (
        <>
            <div className="headerInfo">
                <span className="name">
                    {comment.name}
                </span>

                {comment.logicType && comment.logicType !== 'ANSWER' && (
                    <span className={`logic-badge ${comment.logicType.toLowerCase()}`}>
                        {comment.logicType.replace("_", " ")}
                    </span>
                )}
            </div>

            <p>
                {comment.desc}
            </p>

            {comment.linkUrl && (
                <div className="commentLinkPreview" style={{ marginTop: "10px" }}>
                    <CommentLinkPreview
                        linkUrl={comment.linkUrl} 
                        linkTitle={comment.linkTitle} 
                        linkDesc={comment.linkDesc} 
                        linkImg={comment.linkImg} 
                    />
                </div>
            )}
        </>
    );
};

export default CommentBody;